export const environment = {
  production: false,
  apiUrl: 'https://staging.api.plataforma.convivepro.cl/api',
  docsUrl: 'https://coreui.io/angular',
  prodUrl: 'https://convivepro.cl/'
};
